import { useCallback, useEffect, useState } from "react";
import {
  listCashPickupHabits,
  type CashPickupHabit,
} from "../api/cash-pickup-habits";
import { useSessionStore } from "../store/useSessionStore";

export const useCashPickupHabits = (
  destinationCountry: string
): { habits: CashPickupHabit[]; loading: boolean } => {
  const linkId = useSessionStore((s) => s.session.data?.linkId ?? null);
  const [habits, setHabits] = useState<CashPickupHabit[]>([]);
  const [loading, setLoading] = useState(Boolean(linkId && destinationCountry));

  const load = useCallback(() => {
    if (!linkId || !destinationCountry.trim()) {
      setHabits([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    listCashPickupHabits(linkId, destinationCountry)
      .then(setHabits)
      .catch(() => setHabits([]))
      .finally(() => setLoading(false));
  }, [linkId, destinationCountry]);

  useEffect(() => {
    load();
  }, [load]);

  return { habits, loading };
};
